export default __webpack_public_path__ + "fonts/HelveticaNeueLT-Thin.woff2";